/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Verifyyouremailaddress3Inputs */

const en_settings_verifyyouremailaddress3 = /** @type {(inputs: Settings_Verifyyouremailaddress3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify your email address`)
};

/**
* | output |
* | --- |
* | "Verify your email address" |
*
* @param {Settings_Verifyyouremailaddress3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_verifyyouremailaddress3 = /** @type {((inputs?: Settings_Verifyyouremailaddress3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Verifyyouremailaddress3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_verifyyouremailaddress3(inputs)
});
export { settings_verifyyouremailaddress3 as "settings_verifyYourEmailAddress" }